export default __webpack_public_path__ + "static/media/ordinacija-Office_D127-Cleaneo.0f65d7ae.jpg";